import { Component } from '@angular/core';

@Component({
  selector: 'web-points-shimmer',
  templateUrl: './points-shimmer.component.html',
  styleUrls: ['./points-shimmer.component.scss']
})
export class PointsShimmerComponent {

}
